"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPremiumElementWrapper = void 0;
var CompanyPremiumElemetWrapper_1 = require("./CompanyPremiumElemetWrapper");
Object.defineProperty(exports, "CompanyPremiumElementWrapper", { enumerable: true, get: function () { return CompanyPremiumElemetWrapper_1.CompanyPremiumElementWrapper; } });
